module.exports = __webpack_public_path__ + "img/wait.f46ed29b.svg";